import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type NavType =
  | "home"
  | "create"
  | "manage"
  | "booking"
  | "finance"
  | "profile";

interface UIState {
  headerShown: boolean;
  sidebarActive: boolean;
  activeNavTab: NavType;
}

const initialState: UIState = {
  headerShown: false,
  sidebarActive: false,
  activeNavTab: "home",
};

export const ui = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setHeaderShown: (state, action: PayloadAction<boolean>) => {
      state.headerShown = action.payload;
    },
    setSidebarActive: (state, action: PayloadAction<boolean>) => {
      state.sidebarActive = action.payload;
    },
    setActiveNavTab: (state, action: PayloadAction<NavType>) => {
      state.activeNavTab = action.payload;
    },
  },
});

export const { setHeaderShown, setSidebarActive, setActiveNavTab } = ui.actions;

export default ui.reducer;
